// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"67d0de1f","239":"e9148774","732":"90626eea"}[chunkId] + ".chunk.js";
};